import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

import "./style.css";
import { LeftContent, RightContent } from "../../global-components/src/components/screen/left-content";

const Updates = () => {
    const siteUrl = "https://pacoca.net";
    const pageUrl = `${siteUrl}/blog/atualizacoes`;

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        headline: "Atualizações recentes do Paçoca",
        description:
            "Acompanhe as melhorias, correções de bugs e novas funcionalidades do Paçoca no roadmap público.",
        url: pageUrl,
        author: {
            "@type": "Person",
            name: "João Enrique Barbosa Santos Alves",
        },
        publisher: {
            "@type": "Organization",
            name: "Paçoca Inc.",
            url: siteUrl,
        },
        inLanguage: "pt-BR",
        image: `${siteUrl}/img/pacoca-sem-braco-rounded.png`,
    };

    return (
        <>
          <LeftContent/>
          <RightContent/>
            <Helmet>
                <title>Atualizações – Paçoca</title>
                <meta
                    name="description"
                    content="Acompanhe as últimas atualizações do Paçoca: melhorias, correções de bugs e novas funcionalidades. Roadmap público da rede social brasileira."
                />
                <meta
                    name="keywords"
                    content="atualizações paçoca, novidades paçoca, roadmap paçoca, changelog paçoca, rede social brasileira"
                />
                <meta name="author" content="João Enrique Barbosa Santos Alves" />
                <link rel="canonical" href={pageUrl} />

                <meta property="og:type" content="article" />
                <meta property="og:url" content={pageUrl} />
                <meta property="og:title" content="Atualizações do Paçoca – Rede Social Brasileira" />
                <meta
                    property="og:description"
                    content="Acompanhe as últimas atualizações do Paçoca: melhorias, correções e novas funcionalidades."
                />
                <meta property="og:image" content={`${siteUrl}/img/pacoca-sem-braco-rounded.png`} />
                <meta property="og:locale" content="pt_BR" />
                <meta property="og:site_name" content="Paçoca" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Atualizações do Paçoca – Rede Social Brasileira" />
                <meta
                    name="twitter:description"
                    content="Melhorias, correções e novidades do Paçoca. Acompanhe o roadmap público."
                />
                <meta name="twitter:image" content={`${siteUrl}/img/pacoca-sem-braco-rounded.png`} />

                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            </Helmet>

            <div className="blog-post-page">
                <article>
                    <div className="blog-post-eyebrow">
                        <Link to="/blog">Blog</Link>
                        <span aria-hidden="true">›</span>
                        <span>Updates</span>
                    </div>

                    <h1 className="blog-post-title">Atualizações recentes</h1>

                    <p className="blog-post-lead">
                        Melhorias, correções de bugs e novas funcionalidades — tudo transparente
                        no roadmap público do Paçoca.
                    </p>

                    <hr className="blog-post-divider" />

                    <section>
                        <p>
                            O Paçoca usa um kanban público para registrar o que está sendo feito,
                            o que está em progresso e o que já foi entregue. Você pode acompanhar
                            em tempo real pelo GitHub Projects:
                        </p>
                        <p>
                            <a
                                href="https://github.com/orgs/PacocaOficial/projects/1/views/2"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Ver roadmap no GitHub →
                            </a>
                        </p>
                    </section>

                    <img
                        style={{ width: "100%", borderRadius: 8, marginTop: "1rem" }}
                        src="/img/kanban.png"
                        alt="Kanban do roadmap público do Paçoca no GitHub Projects"
                    />
                </article>
            </div>
        </>
    );
};

export default Updates;